export const noop = () => {}

/* The identity function. */
export const id = <T>(a: T): T => a
